export default __webpack_public_path__ + "static/media/authentication-page-background.9df1ddef.png";